<template>
  <v-app id="v-app">
    <div class="hidden lg:flex items-stretch desktop">
      <div class="list pl-3 pr-4 mt-20 overflow-y-scroll">
        <div
          v-for="(job, index) in jobs"
          @click="selectJob(job, index)"
          :key="index"
          class="block job p-6 mb-3 cursor-pointer"
          :class="{ selected : job === selectedJob, 'no-border': selectedIndex === index || selectedIndex === index + 1 }"
        >
          <p class="title font-bold">{{ job.title[lang] }}</p>
          <p class="mt-2">{{ job.subtitle[lang] }}</p>
          <p class="city my-3 red font-bold">{{ job.city }}</p>
          <p class="text mt-2" v-html="job.text[lang]"></p>
        </div>
      </div>
      <div class="job--selected px-6 pt-6 overflow-y-auto">
        <div class="job no-border">
          <p class="title font-bold text-xl">{{ selectedJob.title[lang] }}</p>
          <p class="mt-3">{{ selectedJob.subtitle[lang] }}</p>
          <p class="city my-4 red font-bold text-sm">{{ selectedJob.city }}</p>
          <p class="text mt-3 mb-8 expanded text-sm" v-html="selectedJob.text[lang]"></p>
        </div>
        <hr class="separator w-full">
        <v-form v-model="valid" ref="form" dark>
          <p class="intro font-semibold mt-8 mb-5">{{ trans.steps[3].form_title}}</p>
          <v-text-field
            dark
            :label="trans.steps[3].name"
            :rules="nameRules"
            v-model="name"
            filled
            rounded
            autocomplete="off"
          ></v-text-field>
          <div class="flex">
            <v-text-field
              dark
              class="w-1/2 pr-2"
              label="Email"
              v-model="email"
              :rules="emailRules"
              filled
              rounded
              autocomplete="off"
            ></v-text-field>
            <v-text-field
              dark
              class="w-1/2 pl-2"
              :label="trans.steps[3].phone"
              :rules="phoneRules"
              v-model="phone"
              filled
              rounded
              autocomplete="off"
            ></v-text-field>
          </div>
          <v-textarea label="Mensaje" :rules="textRules" filled rounded v-model="message"></v-textarea>

          <div class="flex justify-between items-center">
            <p
              class="w-5/12 mb-0 pr-4"
            >{{fileInput ? fileInput.name : 'CV/Resum'}}. {{fileInput ? fileInput.size : 0 }}bytes</p>
            <input
              type="file"
              class="custom-file-input"
              @change="onFileChange"
              name="document"
              id="file"
              ref="file"
              required
            />
            <div class="w-7/12 text-right">
              <label
                class="w-full mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated mdc-button--outlined"
                for="file"
              >
                <span class="mdc-button__label">{{ trans.steps[3].upload }}</span>
              </label>
            </div>
          </div>
          <div class="flex items-center mt-4 lg:mt-0 mb-2 privacy-container">
            <CheckboxVue
              id="privacy"
              :checked="checkboxChecked"
              @update:checked="checkboxChecked = $event"
            >
              <p class="ml-4">
                {{ trans.steps[3].agreeTextPart1 }}
                <a class="topaz" :href="trans.steps[3].privacyPolicyLink" target="_blank">{{ trans.steps[3].privacyPolicyText }}</a>
                {{ trans.steps[3].agreeTextPart2 }}
                <a class="topaz" :href="trans.steps[3].termsLink" target="_blank">{{ trans.steps[3].termsText }}</a>
              </p>
            </CheckboxVue>
          </div>
          <div class="flex items-center mt-2 lg:mt-0 privacy-container">
            <CheckboxVue
              id="privacy-commercial"
              :checked="checkboxCommercialChecked"
              @update:checked="checkboxCommercialChecked = $event"
            >
              <p class="ml-4">{{trans.steps[3].agreeComercial}}</p>
            </CheckboxVue>
          </div>

          <v-btn
            :disabled="!valid || fileInput == ''"
            :loading="loading"
            @click="submitForm()"
            style="height: 45px"
            class="mt-5 mb-3 w-full mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated"
          >
            <span class="mdc-button__label btn-team">Enviar</span>
          </v-btn>
        </v-form>
      </div>
    </div>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="0">
      {{ this.snackText }}
      <v-btn color="white" text @click="snackbar = false">{{ trans.steps[3].close }}</v-btn>
    </v-snackbar>
    <!-- <v-dialog v-model="dialog" persistent overlay-opacity="0.85" max-width="300">
      <v-card>
        <span class="mb-4">Introduce contraseña</span>
        <input type="password" placeholder="Introduce contraseña" v-model="password" class="input-pass">
        <span v-show="error" class="text-red-500 mb-4">Contraseña incorrecta</span>
        <v-spacer></v-spacer>
        <div class="flex content-center">
          <v-btn class="btn-pass" @click="checkPass()">Continuar</v-btn>
        </div>
      </v-card>
    </v-dialog> -->
  </v-app>
</template>

<script>
import axios from "axios";
import CheckboxVue from './Checkbox.vue';

export default {
  props: ["jobs", "trans"],

  components: {
    CheckboxVue,
  },

  data() {
    return {
      selectedIndex: 0,
      selectedJob: this.jobs[0],
      lang: "",
      name: "",
      email: "",
      phone: "",
      message: "",
      valid: false,
      fileInput: "",
      loading: false,
      snackbarColor: "success",
      snackbar: "",
      snackText: "",
      dialog: false,
      password: "",
      error: false,
      checkboxChecked: false,
      checkboxCommercialChecked: false,
      emailRules: [
        v => !!v || this.trans.steps[3].emailRules[0],
        v => /.+@.+\..+/.test(v) || this.trans.steps[3].emailRules[1]
      ],
      phoneRules: [
        v => !!v || this.trans.steps[3].phoneRules[0],
        v => /^\d{9}$/.test(v) || this.trans.steps[3].phoneRules[1]
      ],
      nameRules: [v => !!v || this.trans.steps[3].nameSurname],
      textRules: [v => !!v || this.trans.steps[3].text]
    };
  },

  methods: {
    selectJob(job, index) {
      this.selectedJob = job;
      this.selectedIndex = index;
      this.message = "";
      this.$el.querySelector(".job--selected").scrollTop = 0;
    },
    onFileChange(e) {
      this.fileInput = this.$refs.file.files[0];
    },
    submitForm() {
      this.loading = true;
      let formData = new FormData();
      formData.append("file", this.fileInput);
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("message", this.message);
      formData.append("title", this.selectedJob.title[this.lang]);
      formData.append("city", this.selectedJob.city);

      axios
        .post("/job-form", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          // console.log(res);
          this.loading = false;
          this.snackbar = true;
          this.$refs.form.reset();
          this.snackText = this.trans.steps[3].sent;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.snackbarColor = "info";
          this.snackbar = true;
          this.snackText = this.trans.steps[3].error;
        });
    },
    checkPass() {
      return this.password === "workpallars" ? this.dialog = false : this.error=true;
    }
  },

  created() {
    this.lang = window.appLocale;
  }
};
</script>

<style lang="scss" scoped>
#v-app {
  background-color: #f7f7f7;
}
.v-card{
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .input-pass{
    width: 100%;
    border-radius: 4px;
    border: 1px solid black;
    padding: 0.25rem 0.5rem;
    margin-bottom: 1rem;
  }

  .btn-pass{
    background-color: transparent;
    color: #2b2034;
  }
}
.v-messages__message {
  color: black !important;
}

.custom-file-input {
  position: absolute;
  height: 45px;
  z-index: 5;
  width: 100%;
  max-width: 30px;
  opacity: 0;
}

.v-application .error--text {
  color: #f44336 !important;
  caret-color: #f44336 !important;
}

.separator {
  border: solid 0.5px #979797;
}

.btn-team {
  color: #787878 !important;
}
</style>
